export default [
  {
    zone: 'Asia',
    zoneItems: [
      {
        place: 'Mumbai',
        name: 'BSE Sensex',
        ric: '.BSESN',
        open: '09:15:00',
        close: '15:30:00',
        country: 'IN',
        exchange: '',
        timeZone: 'Asia/Kolkata',
        state: 'closed'
      },
      {
        place: 'Hong Kong',
        name: 'Hang Seng',
        ric: '.HSI',
        open: '09:30:00',
        close: '16:00:00',
        country: 'HK',
        exchange: 'HKG',
        timeZone: 'Asia/Hong_Kong',
        state: 'closed'
      },
      {
        place: 'Tokyo',
        name: 'Nikkei 225',
        ric: '.N225',
        open: '09:00:00',
        close: '15:00:00',
        country: 'JP',
        exchange: 'TYO',
        timeZone: 'Asia/Tokyo',
        state: 'closed'
      },
      {
        place: 'Seoul',
        name: 'KOSPI',
        ric: '.KS11',
        open: '09:00:00',
        close: '15:30:00',
        country: 'KR',
        exchange: 'KSC',
        timeZone: 'Asia/Seoul',
        state: 'closed'
      },
      {
        place: 'Shanghai',
        name: 'Shanghai Composite',
        ric: '.SSEC',
        open: '09:30:00',
        close: '15:00:00',
        country: 'CN',
        exchange: 'SHH',
        timeZone: 'Asia/Shanghai',
        state: 'closed'
      },
      {
        place: 'Taipei',
        name: 'Taiwan Weighted',
        ric: '.TWII',
        open: '09:00:00',
        close: '13:30:00',
        country: 'TW',
        exchange: 'TAI',
        timeZone: 'Asia/Taipei',
        state: 'closed'
      }
    ]
  },
  {
    zone: 'Europe',
    zoneItems: [
      {
        place: 'Frankfurt',
        name: 'DAX',
        ric: '.GDAXI',
        open: '09:00:00',
        close: '17:30:00',
        country: 'DE',
        exchange: 'GER',
        timeZone: 'Europe/Berlin',
        state: 'closed'
      },
      {
        place: 'Moscow',
        name: 'RTS',
        ric: '.IRTS',
        open: '10:00:00',
        close: '18:40:00',
        country: 'RU',
        exchange: 'RTF',
        timeZone: 'Europe/Moscow',
        state: 'closed'
      },
      {
        place: 'Paris',
        name: 'CAC 40',
        ric: '.FCHI',
        open: '09:00:00',
        close: '17:30:00',
        country: 'FR',
        exchange: 'PAR',
        timeZone: 'Europe/Berlin',
        state: 'closed'
      },
      {
        place: 'London',
        name: 'FTSE 100',
        ric: '.FTSE',
        open: '08:00:00',
        close: '16:30:00',
        country: 'GB',
        exchange: 'LSE',
        timeZone: 'Europe/London',
        state: 'closed'
      },
      {
        place: 'Europe',
        name: 'ESTX50',
        ric: '.STOXX50E',
        open: '09:00:00',
        close: '17:30:00',
        country: 'EU',
        exchange: 'EU',
        timeZone: 'Europe/Berlin',
        state: 'closed'
      }
    ]
  },
  {
    zone: 'Australia',
    zoneItems: [
      {
        place: 'Sydney',
        name: 'All Ordinaries',
        ric: '.AORD',
        open: '10:00:00',
        close: '16:00:00',
        country: 'AU',
        exchange: 'ASE',
        timeZone: 'Australia/Sydney',
        state: 'closed'
      }
    ]
  },
  {
    zone: 'Pacific',
    zoneItems: [
      {
        place: 'Auckland',
        name: 'New Zealand SX50',
        ric: '.NZ50',
        open: '10:00:00',
        close: '16:45:00',
        country: 'NZ',
        exchange: 'NZC',
        timeZone: 'Pacific/Auckland',
        state: 'closed'
      }
    ]
  },
  {
    zone: 'America',
    zoneItems: [
      {
        place: 'New York',
        name: 'Dow Jones',
        ric: '.DJI',
        open: '09:00:00',
        close: '16:30:00',
        country: 'US',
        exchange: 'NYS',
        timeZone: 'America/New_York',
        state: 'closed'
      },
      {
        place: 'New York',
        name: 'NASDAQ 100',
        ric: '.NDX',
        open: '09:00:00',
        close: '16:30:00',
        country: 'US',
        exchange: 'NAS',
        timeZone: 'America/New_York',
        state: 'closed'
      },
      {
        place: 'Toronto',
        name: 'TSX 60',
        ric: '.SPTSE',
        open: '09:00:00',
        close: '16:30:00',
        country: 'CA',
        exchange: 'TOR',
        timeZone: 'America/Toronto',
        state: 'closed'
      },
      {
        place: 'Sao Paulo',
        name: 'Bovespa',
        ric: '.BVSP',
        open: '10:00:00',
        close: '16:55:00',
        country: 'BR',
        exchange: 'SAO',
        timeZone: 'America/Sao_Paulo',
        state: 'closed'
      },
      {
        place: 'Mexico City',
        name: 'MXN',
        ric: '.MXX',
        open: '08:30:00',
        close: '15:00:00',
        country: 'AR',
        exchange: 'BUE',
        timeZone: 'America/Mexico_City',
        state: 'closed'
      }
    ]
  }
];
